import React from 'react';
import clsx from 'clsx';
import { TagsLineV2 } from 'types/studio/studio';
import { CheckmarkIcon } from '@ag1/ui';
import styles from './Tag.module.scss';

type TagProps = {
  text?: string;
};

const Tag = ({ text }: TagProps & Pick<TagsLineV2, 'bgColor'>) => (
  <div className={styles.tag}>
    <CheckmarkIcon className={clsx(styles.icon)} size={20} strokeWidth={1.5} />
    <span className={clsx(styles.text)}>{text}</span>
  </div>
);

export default Tag;
